<!-- https://8es9hr.axshare.com/#g=1&p=%E8%BD%89%E5%B8%B3%E5%82%B3%E7%A5%A8 -->
<!-- 轉帳傳票 -->
<template>
  <div class="row">
    <div class="col-12">
      <div class="col-block" v-if="this.$route.meta.formKeepAlive">
        <div class="block-header has-border">
          <h3 v-if="dataArr !== undefined">
            <strong
              >{{ dataArr.member.account }}
              {{ dataArr.member.idNumber }}
              {{ dataArr.member.name }}</strong
            >
          </h3>
          <br />
          <!-- 只有社員可以搜尋其他社員 -->
          <h3>
            <strong>轉帳傳票開立作業</strong>
          </h3>
          <el-button class="ml10" plain @click="openAddWork"
            >新增匯款對象</el-button
          >
          <el-button type="primary" plain @click="viewNote"
            >檢視轉帳記事</el-button
          >
        </div>
        <div class="block-content">
          <!-- 匯款日期 -->
          <el-card class="box-card">
            <div class="row">
              <div class="col-4">
                <p class="bold">匯款日期</p>
                <div class="date">
                  <input
                    type="text"
                    class="min_go_date selectDate"
                    placeholder="選擇日期"
                  />
                  <span class="el-input__prefix" style="margin-top: 10px">
                    <i class="el-icon-date"></i>
                  </span>
                </div>
              </div>
              <div class="col-4">
                <p class="bold">銀行帳戶</p>
                {{ bankData.bankCode }} {{ bankData.bankName }}
              </div>
              <div class="col-4">
                <p class="bold">總金額</p>
                <!-- <el-input placeholder="請輸入金額">
                                    {{totalPayment(work)}}
								</el-input>-->
                {{ allMemberTotalPayment() }}
              </div>
            </div>
          </el-card>
          <!-- 匯款對象 -->
          <el-card
            class="box-card"
            v-for="(work, workIndex) in works"
            :key="workIndex"
          >
            {{ work.account }} {{ work.name }}
            <el-button
              class="ml10"
              type="danger"
              plain
              @click="removeMember(workIndex)"
              v-if="!work.need"
              >移除匯款對象</el-button
            >
            <div class="mt10">
              <span class="mr10">匯款日期:</span>
              <div class="date mt10">
                <input
                  type="text"
                  class="min_go_date"
                  :class="`${'chooseDate' + workIndex}`"
                  placeholder="選擇日期"
                  :disabled="true"
                />
                <span class="el-input__prefix" style="margin-top: 10px">
                  <i class="el-icon-date"></i>
                </span>
              </div>
            </div>
            <table class="table table-bordered mb-0 mt10">
              <thead class="grey lighten-4">
                <tr>
                  <th>會計科目</th>
                  <th>社員帳號</th>
                  <th>金額</th>
                  <th>摘要</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(content, itemIndex) in work.detail"
                  :key="itemIndex"
                >
                  <td>{{ content.name }}</td>
                  <td>{{ content.memberAccount }} {{ content.memberName }}</td>
                  <td
                    v-if="content.iouRowSpan != 0"
                    :rowspan="content.iouRowSpan || 1"
                  >
                    <el-input
                      v-model="content.amount"
                      placeholder="請輸入金額"
                      :disabled="content.disabled"
                      v-on:input="
                        resetAmount(content.amount, workIndex, itemIndex)
                      "
                    ></el-input>
                  </td>
                  <td>{{ content.show }}</td>
                  <td
                    v-if="content.iouRowSpan != 0"
                    :rowspan="content.iouRowSpan || 1"
                  >
                    <el-button
                      v-if="content.isIouRow"
                      type="primary"
                      plain
                      @click="showRepaymentInfo(currentIndex, itemIndex)"
                      class="mr10"
                      >還款試算</el-button
                    >
                  </td>
                  <td
                    v-if="content.iouRowSpan != 0"
                    :rowspan="content.iouRowSpan || 1"
                  >
                    <el-button
                      type="danger"
                      plain
                      @click="removeItem(workIndex, itemIndex)"
                      >移除項目</el-button
                    >
                  </td>
                </tr>
                <tr>
                  <td>小計</td>
                  <td>{{ totalPayment(work) }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <div class="mt10">
              <el-button plain @click="openAddItem(work, workIndex)"
                >新增匯款項目</el-button
              >
            </div>
            <h3>備註</h3>
            <el-select
              v-model="works[workIndex].Glossary"
              placeholder="中文詞彙"
              class="ml10 mt10"
            >
              <el-option
                v-for="item in Glossary"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button
              type="primary"
              plain
              class="ml10"
              @click="importGlossary(workIndex)"
              >插入</el-button
            >
            <el-input
              class="mt10"
              v-model="works[workIndex].remark"
              type="textarea"
              :rows="4"
              placeholder="請輸入內容"
            ></el-input>
          </el-card>
          <!-- footer -->
          <h3>
            共 {{ works.length }} 張 匯款單 金額總計：{{
              allMemberTotalPayment()
            }}
          </h3>
          <el-button
            type="primary"
            class="ml10"
            plain
            v-if="works.length >= 1"
            @click="submit"
            >開立轉帳傳票</el-button
          >
          <el-button class="ml10" plain @click="back">返回</el-button>
        </div>
        <!-- 新增匯款對象 -->
        <el-dialog
          custom-class="member-group"
          title="新增匯款對象"
          :visible.sync="dialogAddWork"
          :append-to-body="true"
          width="300px"
        >
          <ListForm
            api="member"
            :recordToEdit="addMemberObj"
            labelPosition="top"
            :formType="formType"
          >
            <div slot="footer" class="dialog-footer"></div>
          </ListForm>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogAddWork = false">取消</el-button>
            <el-button type="primary" @click="saveAddWork()">確定</el-button>
          </div>
        </el-dialog>
        <!-- 新增匯款項目 -->
        <el-dialog
          :visible.sync="dialogAddItem"
          :append-to-body="true"
          width="370px"
        >
          <el-form label-position="top">
            <ListForm
              api="member"
              :recordToEdit="addMemberObj"
              labelPosition="top"
              :formType="formType"
            >
              <div slot="footer" class="dialog-footer"></div>
            </ListForm>
            <el-form-item label="匯款項目">
              <el-select
                placeholder="請選擇類別"
                v-model="currentAddItem.type"
                style="width: 100%"
                @change="chooseType(currentIndex, currentAddItem, true)"
              >
                <el-option
                  v-for="item in getOptions(currentIndex)"
                  :key="item.value"
                  :label="item.code + ' ' + item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                placeholder="請選擇方案"
                class="mt10"
                :filterable="true"
                v-model="currentAddItem.chooseRepayment"
                @change="
                  (val) => {
                    getAmount(currentAddItem, currentIndex);
                  }
                "
                v-show="isShowOptionSelection"
              >
                <el-option
                  v-for="option of currentAddItem.iouList"
                  :key="option.id"
                  :label="
                    currentAddItem.type === 2
                      ? `${option.iouNumber}`
                      : currentAddItem.type === 6
                      ? option.coopLoanIouNumber
                      : currentAddItem.type === 5
                      ? `${option.label}`
                      : option.label
                  "
                  :value="
                    currentAddItem.type === 2
                      ? `${option.iouNumber}`
                      : currentAddItem.type === 5
                      ? `${option.value}`
                      : currentAddItem.type == 3 || currentAddItem.type == 6
                      ? option
                      : option.value
                  "
                ></el-option>
              </el-select>
              <el-select
                placeholder="請選擇年度"
                class="mt10"
                :filterable="true"
                v-model="currentAddItem.selectYear"
                v-show="isShowYearSelection"
                @change="
                  (val) => {
                    getAmount(currentAddItem, currentIndex);
                  }
                "
              >
                <el-option
                  v-for="option of yearList"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="金額">
              <el-input
                v-model="currentAddItem.amount"
                :disabled="inputDsabled"
                v-on:input="resetAddAmount(currentAddItem.amount)"
              ></el-input>
            </el-form-item>
            <el-form-item label="摘要">
              <el-input
                type="textarea"
                v-model="currentAddItem.note"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogAddItem = false">取消</el-button>
            <el-button
              type="primary"
              @click="saveAddItem(currentAddItem, currentIndex)"
              >確定</el-button
            >
          </div>
        </el-dialog>
        <!-- 檢視轉帳記事 -->
        <el-dialog
          :visible.sync="dialogTransferView"
          :append-to-body="true"
          title="轉帳記事"
          width="450px"
          center
        >
          <ListForm
            api="member"
            :recordToEdit="recordToEdit"
            labelPosition="top"
            :formType="formType2"
          >
            <div slot="footer" class="dialog-footer"></div>
          </ListForm>
        </el-dialog>

        <el-dialog
          :visible.sync="loanModal"
          :append-to-body="true"
          :close-on-click-modal="false"
        >
          <div slot="title">
            <p
              v-if="loanModal"
              class="fs15"
              style="display: inline-block; margin-right: 10px"
            >
              {{ loanIouNumber }} 還款 {{ receiptDate }} 試算結果
              <el-button
                type="primary"
                plain
                @click="showRepaymentInfo(currentIndex, loanRowIndex)"
                class="mr10"
                >變更日期</el-button
              >
              <span class="mt10">
                <input
                  type="text"
                  name="mingo"
                  class="min_go_date iouCalculateDate"
                  placeholder="選擇日期"
                />
                <span class="el-input__prefix"></span>
              </span>
            </p>
          </div>
          <div>
            <p class="fs15">上次償還日期: {{ iouObj.lastPayDate }}</p>
            <p class="fs15">
              剩餘本金: {{ $addcomma(iouObj.loanPriceAfterPay) }}
            </p>
            <p class="fs15">當下利率: {{ iouObj.normalAnnualRate }}</p>
            <p class="fs15">還款寬限日: {{ iouObj.securedGraceDay }}</p>
            <p class="fs15">違約金利率: {{ iouObj.loanPenalty }}</p>
            <p class="fs15">
              前欠利息:
              {{ $addcomma(iouObj.interestNotPayBefore) }}
            </p>
            <p class="fs15">
              前欠違約金:
              {{ $addcomma(iouObj.breakNotPayBefore) }}
            </p>
            <p class="fs15">
              應還利息減免金額:
              {{ $addcomma(iouObj.interestAmountReduction) }}
            </p>
            <p class="fs15">
              應還違約金減免金額:
              {{ $addcomma(iouObj.breakAmountReduction) }}
            </p>

            <p class="fs15">
              應繳本金:
              {{ $addcomma(iouObj.payBackLoanPrice) }}
            </p>
            <p class="fs15">
              應繳利息(含前欠):
              {{ $addcomma(iouObj.payBackInterest) }}
            </p>
            <p class="fs15">
              應繳違約金(含前欠):
              {{ $addcomma(iouObj.payBackBreakPrice) }}
            </p>
          </div>
          <div v-for="(detail, id) in iouObj.detail" :key="id">
            <table class="table table-bordered mb-0">
              <thead class="grey lighten-4">
                <tr>
                  <th colspan="3">
                    <h3>
                      <strong>第{{ detail.stage }}期</strong>
                    </h3>
                  </th>
                </tr>
              </thead>
              <thead class="grey lighten-4">
                <tr>
                  <th>應還項目</th>
                  <th>應還金額</th>
                  <th>金額細節</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>應還本金</td>
                  <td>
                    {{ $addcomma(detail.stageLoanPay) }}
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>應還利息</td>
                  <td>
                    {{ $addcomma(detail.stageInterest) }}
                  </td>
                  <td style="overflow-x: scroll">
                    <p style="white-space: nowrap; width: 150px">
                      {{
                        renderCauculateString(
                          detail.interestRateDetail,
                          detail.paymentType
                        )
                      }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>應還違約金</td>
                  <td>{{ $addcomma(detail.breakPrice) }}</td>
                  <td style="overflow-x: scroll">
                    <p style="white-space: nowrap; width: 150px">
                      {{
                        renderCauculateString(detail.breakPriceDetail, 1, true)
                      }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>總計</td>
                  <td>
                    {{ $addcomma(detail.stagePayBack) }}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-dialog>
      </div>
      <router-view v-else></router-view>
    </div>
  </div>
</template>
<script>
import { API } from "@/assets/config";
import ListForm from "@/components/ListForm.vue";

export default {
  name: "cabinet_transfer_summons",
  components: { ListForm },
  data() {
    let memberFilter = {
      isFormal: 1,
    };
    return {
      loanIouNumber: "",
      loanRowIndex: 0,
      loanModal: false,
      iouObj: {},
      dataArr: this.$route.params.detail,
      id: this.$route.params.id,
      subId: this.$route.params.subId || "",
      memberFilter,
      firstName: "",
      lastName: "",
      isShowOptionSelection: false,
      isShowYearSelection: false,
      inputDsabled: false,
      recordToEdit: {},
      bankData: {},
      works: [],
      yearList: [],
      iouenumData: [],
      receiptDate: "",
      totalAmount: "",
      totalAmouts: 0,
      dialogAddWork: false,
      dialogAddItem: false,
      dialogTransferView: false,
      reportIdList: [],
      currentAddWork: {
        code: "",
        id: "",
        name: "",
        date: "",
      },
      currentAddItem: {
        chooseRepayment: "",
        amount: 0,
        type: 0,
        note: "",
        iouObj: {},
        name: "",
        display: true,
        isRepayment: false,
        tradeDate: "",
        otherItem: [],
      },
      // 將新增款項重製
      defaultAddItem: {
        chooseRepayment: "",
        amount: 0,
        type: "",
        note: "",
        iouObj: {},
        name: "",
        isRepayment: false,
        otherItem: [],
        currentOtherItem: {},
      },
      addMemberObj: {},
      currentIndex: 0,
      applyMemberOptions: [],
      accountTitle: [],
      // 正式社員匯款項目（準社員改由 applyMemberOptions / getByApplyMember）
      options: [
        { id: 191, code: 3101, value: 0, label: "股金" },
        { id: 88, code: 2311, value: 1, label: "備轉金" },
        { code: "", value: 2, label: "還款" },
        { code: "", value: 6, label: "協議前欠" },
        { code: "", value: 3, label: "代辦互助基金" },
        { code: "", value: 4, label: "六年平儲" },
        { code: "", value: 7, label: "社員年費", type: 1 },
        { code: "", value: 8, label: "呆帳轉銷後收回", type: 1 },
        { code: "", value: 5, label: "其他會計科目" },
      ],
      // 中文詞彙
      Glossary: [],
      accountTitleEnum: {
        0: {
          id: 191,
          code: 3101,
          name: "股金",
        },
        1: {
          id: 88,
          code: 2311,
          name: "備轉金",
        },
        2: {
          code: "",
          name: "",
        },
        3: {
          code: "",
          name: "代辦互助基金",
        },
        4: {
          code: "",
          name: "六年平儲",
        },
        5: {
          code: "",
          name: "其他會計科目",
        },
      },
      formType: [
        {
          label: "匯款對象",
          key: "memberType",
          type: "radio",
          options: [
            {
              label: "社員",
              value: 1,
            },
            {
              label: "準社員",
              value: 0,
            },
          ],
        },
        {
          label: "帳號",
          key: "chooseMember",
          type: "chooseMember",
          filter: memberFilter,
        },
      ],
      formType2: [
        {
          label: "匯款日期",
          type: "date",
          key: "transferDate",
          disabled: true,
        },
        {
          label: "匯到哪個銀行帳戶",
          type: "input",
          key: "bankCode",
          disabled: true,
        },
        {
          label: "匯款帳號後五碼",
          type: "input",
          key: "transferAccountNumber",
          disabled: true,
        },
        {
          label: "匯款金額",
          type: "input",
          key: "transferAmount",
          disabled: true,
        },
        {
          label: "用途說明",
          type: "input",
          key: "note",
          disabled: true,
        },
      ],
    };
  },
  created() {
    this.works = [];

    this.loadApplyMemberOptions();
    this.getData();

    this.getGlossary();
    this.setYearList();
  },
  computed: {
    tranferData() {
      return this.works.map((item) => {
        let newItem = {
          ...item,
          detail: [],
        };
        newItem.detail = item.detail.map((details) => {
          if (details.isIouRow) {
            return {
              ...details,
              creditAmount: details.currentAmount,
              amount: details.currentAmount,
            };
          } else {
            return {
              ...details,
              creditAmount: details.amount.toString().replace(/,/g, ""),
              amount: details.amount.toString().replace(/,/g, ""),
            };
          }
        });
        return newItem;
      });
    },
  },
  watch: {
    "currentAddItem.type": {
      handler(key) {
        this.currentAddItem.iouList = [];
        this.currentAddItem.amount = "";
        this.currentAddItem.selectYear = "";
      },
    },
    "addMemberObj.memberType": {
      handler(key) {
        this.memberFilter.isFormal = key;
        if (this.dialogAddItem) {
          this.currentAddItem.type = "";
        }
      },
      deep: true,
    },
    "addMemberObj.chooseMember": {
      handler(newVal) {
        if (newVal && newVal.id && this.currentAddItem.type !== "") {
          // 刷新下拉選單
          this.currentAddItem = Object.assign({}, this.defaultAddItem); 
          // 撈取預設社員資料
          this.chooseType(this.currentIndex, this.currentAddItem, true);
        }
      },
      deep: true
    }
  },
  methods: {
    showRepaymentInfo(workIndex, rowIndex) {
      const form = new FormData();
      const url = API.coopLoanIou + "?action=getCalByDate";
      const thenCB = (json) => {
        this.iouObj = json.resultData;
        // this.handleTableData(json.resultData);
        this.loanModal = true;
        this.loanIouNumber =
          this.works[workIndex].detail[rowIndex].loanIouNumber;
        this.loanRowIndex = rowIndex;
        this.currentIndex = workIndex;
        setTimeout(() => {
          $(".min_go_date").datepicker({
            changeYear: true,
            changeMonth: true,
            currentText: "今天",
            dateFormat: "Rmmdd",
            showButtonPanel: true,
          });
        }, 2);
      };

      if (
        $(".iouCalculateDate").val() !== undefined &&
        $(".iouCalculateDate").val() !== ""
      ) {
        this.receiptDate = $(".iouCalculateDate").val();
        let date =
          parseInt($(".iouCalculateDate").val().split("-")[0]) +
          1911 +
          $(".iouCalculateDate").val().slice(3);

        form.append("baseDate", date);
      } else {
        let tradeDate = this.works[workIndex].tradeDate;
        this.receiptDate =
          parseInt(tradeDate.split("-")[0]) - 1911 + tradeDate.slice(4);

        form.append("baseDate", tradeDate);
      }

      form.append(
        "iouNumber",
        this.works[workIndex].detail[rowIndex].loanIouNumber
      );

      this.mAxiosPost(url, form, thenCB);
    },
    getOptions(currentIndex) {
      const isApplyMember =
        (this.dialogAddItem && this.addMemberObj.memberType == 0) ||
        (!this.dialogAddItem &&
          this.works[currentIndex] &&
          this.works[currentIndex].memberType == 0);

      if (isApplyMember) {
        return this.applyMemberOptions;
      }
      return this.options;
    },
    loadApplyMemberOptions() {
      const url =
        API.coopAccountTitle + "?action=getByApplyMember&scenario=transfer";
      const thenCB = (json) => {
        const baseType = 11;
        this.applyMemberOptions = (json.resultData || []).map((item, index) => {
          const type = baseType + index;
          this.$set(this.accountTitleEnum, type, {
            id: item.id,
            code: item.code,
            name: item.name,
          });
          return {
            id: item.id,
            code: item.code,
            value: type,
            label: item.name,
            type: 0,
          };
        });
      };
      this.mAxiosGet(url, thenCB);
    },
    setDefaultDate(dateTime) {
      dateTime = dateTime.split(" ")[0];
      setTimeout(() => {
        $(".min_go_date").datepicker({
          changeYear: true,
          changeMonth: true,
          currentText: "今天",
          dateFormat: "Rmmdd",
          showButtonPanel: true,
          yearRange: "1912:c+10",
        });

        let dd = dateTime.split("-")[2];
        let mm = dateTime.split("-")[1];
        let yyy = String(parseInt(dateTime.split("-")[0]) - 1911).padStart(
          3,
          "0"
        );
        $(`.selectDate`).val(`${yyy}-${mm}-${dd}`);
      }, 10);
    },
    chooseType(
      currentIndex,
      currentItem,
      isOpenOption = false,
      injectionFunction = null
    ) {
      let urlSelect = "";
      let thenCB = null;

      // 取得當前目標社員
      const targetMember = this.getTargetMember(currentIndex);
      const targetMemberId = targetMember.id;

      switch (currentItem.type) {
        // 撈取股金列表
        // 撈取備轉金列表
        // 社員儲金
        case 0:
        case 1:
        case 10:
          currentItem.chooseRepayment = "";
          currentItem.amount = "";
          urlSelect = "";
          if (isOpenOption) {
            this.isShowOptionSelection = false;
            this.isShowYearSelection = false;
            this.inputDsabled = false;
          }
          if (injectionFunction) {
            injectionFunction();
          }

          break;
        case 7:
          if (isOpenOption) {
            this.isShowOptionSelection = false;
            this.isShowYearSelection = true;
            this.inputDsabled = true;
          }
          if (injectionFunction) {
            injectionFunction();
          }

          break;
        // 撈取借據列表
        case 2:
          currentItem.chooseRepayment = "";
          currentItem.amount = "";
          urlSelect =
            API.coopLoanIou +
            `?action=getListByMember&memberId=${targetMemberId}`;
          thenCB = (json) => {
            currentItem.iouList = json.resultData;
            if (injectionFunction) {
              injectionFunction();
            }

            if (isOpenOption) {
              this.isShowOptionSelection = true;
              this.isShowYearSelection = false;
              this.inputDsabled = false;
            }
          };
          this.mAxiosGet(urlSelect, thenCB);

          break;
        // 撈取代辦互助基金列表
        case 3:
          currentItem.chooseRepayment = "";
          currentItem.amount = "";
          urlSelect =
            API.coopInsPlanMember +
            `?action=getInsPlanByMember&memberId=${targetMemberId}`;
          thenCB = (json) => {
            currentItem.iouList = json.resultData.map((item) => {
              return {
                value: item.insPlanMainCode,
                label: item.insPlanMainName,
                noPayAmount: item.diffAmount,
                insPlanApplyNumber: item.insPlanMemberApplyId,
                accountTitleId: item.colAccountTitle.id,
                accountTitleCode: item.colAccountTitle.code,
                insPlanMemberApplyId: item.insPlanMemberApplyId,
              };
            });

            if (injectionFunction) {
              injectionFunction();
            }

            if (isOpenOption) {
              this.isShowOptionSelection = true;
              this.isShowYearSelection = false;
              this.inputDsabled = true;
            }
          };
          this.mAxiosGet(urlSelect, thenCB);

          break;
        // 撈取六年平儲列表
        case 4:
          currentItem.chooseRepayment = "";
          currentItem.amount = "";
          urlSelect =
            API.coopInsSavingApply +
            `?action=getMemberNotEnd&memberId=${targetMemberId}`;
          thenCB = (json) => {
            currentItem.sixYearData = json.resultData;
            currentItem.iouList = json.resultData.data.map((item) => {
              return {
                label: item.insSavingCode,
                value: item.insSavingCode,
                priceTotal: item.advAmount + item.advFeeAmount,
                accountTitleSixYear: {
                  label: `${json.resultData.enumData.accountTitleSixYear.code} ${json.resultData.enumData.accountTitleSixYear.name}`,
                  value: json.resultData.enumData.accountTitleSixYear.id,
                  amount: item.advAmount,
                },
                accountTitleSixYearInterest: {
                  label: `${json.resultData.enumData.accountTitleSixYearInterest.code} ${json.resultData.enumData.accountTitleSixYearInterest.name}`,
                  value:
                    json.resultData.enumData.accountTitleSixYearInterest.id,
                  amount: item.advFeeAmount,
                },
              };
            });

            if (injectionFunction) {
              injectionFunction();
            }

            if (isOpenOption) {
              this.isShowOptionSelection = true;
              this.isShowYearSelection = false;
              this.inputDsabled = true;
            }
          };
          this.mAxiosGet(urlSelect, thenCB);

          break;
        // 撈取其他列表
        case 5:
          currentItem.chooseRepayment = "";
          currentItem.amount = "";
          urlSelect = API.coopAccountTitle + `?action=getByManualReceipt`;
          thenCB = (json) => {
            currentItem.otherItem = json.resultData;
            currentItem.iouList = json.resultData.map((item) => {
              return {
                label: `${item.code} ${item.name}`,
                value: item.id,
                code: item.code,
                name: item.name,
              };
            });

            if (injectionFunction) {
              injectionFunction();
            }

            if (isOpenOption) {
              this.isShowOptionSelection = true;
              this.isShowYearSelection = false;
              this.inputDsabled = false;
            }
          };
          this.mAxiosGet(urlSelect, thenCB);

          break;
        // 撈取協議前欠
        case 6:
          currentItem.chooseRepayment = "";
          currentItem.amount = "";
          urlSelect = urlSelect =
            API.coopLoanIou +
            `?action=getMemberAgrBackpayNotPay&memberId=${targetMemberId}`;
          thenCB = (json) => {
            currentItem.iouList = json.resultData.data;

            if (injectionFunction) {
              injectionFunction();
            }

            if (isOpenOption) {
              this.isShowOptionSelection = true;
              this.isShowYearSelection = false;
              this.inputDsabled = true;
            }
          };
          this.mAxiosGet(urlSelect, thenCB);

          break;

        // 呆帳轉銷
        case 8:
          urlSelect =
            API.coopLoanIouDead +
            `?action=getMemberIouDeadList&memberId=${targetMemberId}`;
          this.$http.get(urlSelect).then((res) => {
            currentItem.iouList = res.data.resultData.data.map((item) => {
              return {
                ...item,
                label: item.iouNumber,
                value: item.id,
              };
            });
            currentItem.iouenumData = res.data.resultData.enumData;

            if (injectionFunction) {
              injectionFunction();
            }

            if (isOpenOption) {
              this.isShowOptionSelection = true;
              this.isShowYearSelection = false;
              this.inputDsabled = true;
            }
          });

          break;
        default:
          urlSelect = "";
          if (isOpenOption) {
            this.isShowOptionSelection = false;
            this.isShowYearSelection = false;
            this.inputDsabled = false;
          }
          if (injectionFunction) {
            injectionFunction();
          }
      }
    },
    getMemberData() {
      const vm = this;
      const url = API.counterWork + `?id=${this.id}&action=getMemberData`;
      const thenCB = (json) => {
        this.saveAddWork(json.resultData.memberInfo.member);
        this.dataArr = json.resultData[0];
      };

      this.mAxiosGet(url, thenCB);
    },
    getData() {
      const url = API.memberTransferMemo + `?id=${this.subId}`;
      const thenCB = (json) => {
        let newObj = {
          ...json.resultData.data,
          transferAmount: this.$addcomma(json.resultData.data.transferAmount),
        };
        this.recordToEdit = Object.assign({}, this.recordToEdit, newObj);
        this.bankData = json.resultData.enumData;
        this.recordToEdit.bankCode = json.resultData.enumData.bankCode;
        this.setDefaultDate(json.resultData.data.transferDate);

        this.id = this.id == null ? json.resultData.data.memberId : this.id;
        this.getMemberData();
      };
      this.mAxiosGet(url, thenCB);
    },
    go(name) {
      this.$router.push({ name: name });
    },
    getAmount(currentItem, currentIndex, injectionFunction = null) {
      const targetMember = this.getTargetMember(currentIndex);

      if (currentItem.type === 3) {
        currentItem.amount = this.$addcomma(
          currentItem.chooseRepayment.noPayAmount
        );
        currentItem.name = currentItem.chooseRepayment.insPlanMainName;
        if (injectionFunction !== null) {
          injectionFunction();
        }
      }
      if (currentItem.type === 4) {
        currentItem.amount = currentItem.iouList.filter(
          (sixYear) => sixYear.value == currentItem.chooseRepayment
        )[0].priceTotal;
        if (injectionFunction !== null) {
          injectionFunction();
        }
        // currentItem.name = currentItem.chooseRepayment.insPlanMainName;
      } else if (currentItem.type === 2) {
        let date =
          parseInt($(`.selectDate`).val().split("-")[0]) +
          1911 +
          $(`.selectDate`).val().slice(3);
        let form = new FormData();

        let urlSelect = API.coopLoanIou + `?action=voucherGetCalByDate`;
        form.append("iouNumber", currentItem.chooseRepayment);
        form.append("baseDate", date);
        let thenCB = (json) => {
          currentItem.iouObj = json.resultData;
          if (injectionFunction !== null) {
            injectionFunction();
          }
        };
        this.mAxiosPost(urlSelect, form, thenCB);
      } else if (currentItem.type === 5) {
        currentItem.otherItem.filter((item) => {
          if (item.id == Number(currentItem.chooseRepayment)) {
            currentItem.currentOtherItem = item;
          }
        });
        if (injectionFunction !== null) {
          injectionFunction();
        }
      } else if (currentItem.type == 7) {
        let urlSelect =
          API.member +
          `?action=ActionGetMemberAnnualCost&id=${targetMember.id}&year=${currentItem.selectYear}`;
        let thenCB = (json) => {
          currentItem.amount = this.$addcomma(json.resultData.data);
          currentItem.iouObj = json.resultData.enumData.annualAccountTitle;
          if (injectionFunction !== null) {
            injectionFunction();
          }
        };
        this.mAxiosGet(urlSelect, thenCB);
      } else if (currentItem.type == 6) {
        let url =
          API.coopLoanIou +
          `?action=getAgrBackpay&coopLoanIouId=${currentItem.chooseRepayment.coopLoanIouId}&baseDate=${this.works[currentIndex].tradeDate}`;
        let thenCB = (json) => {
          currentItem.iouList = json.resultData.data;
          currentItem.iouenumData = json.resultData.enumData;

          let sumAmount = 0;

          Object.keys(json.resultData.data).forEach((_key) => {
            let calculateObject = json.resultData.data[_key];
            if (calculateObject.length > 0) {
              sumAmount +=
                calculateObject[calculateObject.length - 1].backPayPriceTotal ||
                0;
            }
          });

          currentItem.amount = sumAmount;

          if (injectionFunction !== null) {
            injectionFunction();
          }
        };
        this.mAxiosGet(url, thenCB);
      } else if (currentItem.type === 8) {
        currentItem.iouList.filter((item) => {
          if (item.id == currentItem.chooseRepayment) {
            currentItem.currentOtherItem = item;
            currentItem.amount = item.iouPrincipalDealAmount;
          }
        });
        if (injectionFunction !== null) {
          injectionFunction();
        }
      }
    },
    openAddWork() {
      let date =
        parseInt($(`.selectDate`).val().split("-")[0]) +
        1911 +
        $(`.selectDate`).val().slice(3);
      if (date == "NaN") {
        this.$message.closeAll();
        this.$message({
          type: "warning",
          message: "請選擇匯款日期",
        });
        return;
      }
      this.receiptDate =
        parseInt($(`.selectDate`).val().split("-")[0]) +
        $(`.selectDate`).val().slice(3);
      this.dialogAddWork = true;
    },
    /**
     * 新增匯款對象
     * @param memberAdd 社員
     * @return void
     */
    saveAddWork(memberAdd = null) {
      this.dialogAddWork = false;
      let date = parseInt($(`.selectDate`).val().split("-")[0])
        + 1911
        + $(`.selectDate`).val().slice(3);
      let addworkd = {};
      if (memberAdd == null) {
        addworkd = {
          detail: [],
          tradeDate: date,
          transferId: Number(this.subId),
          name: this.addMemberObj.chooseMember.name,
          account: this.addMemberObj.chooseMember.account,
          memberId: this.addMemberObj.chooseMember.id,
          memberType: this.addMemberObj.memberType,
          remark: "",
        };
      } else {
        addworkd = {
          name: memberAdd.name,
          account: memberAdd.account,
          memberId: memberAdd.id,
          memberType: memberAdd.isFormal,
          detail: [],
          tradeDate: date,
          transferId: Number(this.subId),
          remark: "",
        };
      }
      this.works.push(addworkd);

      setTimeout(() => {
        this.workTimeOut(this.works);
        this.autoAddItem();
      }, 100);
    },
    autoAddItem() {
      let workIndex = this.works.length - 1;
      const work = this.works[workIndex];

      // 準社員：自動帶出儲蓄部儲金（2301）一筆
      if (work && work.memberType === 0) {
        const savingOption = this.applyMemberOptions.find(
          (item) => String(item.code) === "2301"
        );
        if (!savingOption) {
          return;
        }
        const currentItem = { type: savingOption.value, amount: 0 };
        this.chooseType(workIndex, currentItem, false, () => {
          currentItem.amount = 0;
          this.saveAddItem(currentItem, workIndex);
        });
        return;
      }

      let options = this.getOptions(workIndex);

      for (let i = 0; i < options.length; i++) {
        let type = options[i];

        if (type.value == 5) continue;

        let currentItem = { type: type.value };

        let tmpFunctionInject = null;

        switch (type.value) {
          case 0:
          case 1:
            tmpFunctionInject = () => {
              currentItem.amount = 0;
              this.saveAddItem(currentItem, workIndex);
            };
            break;
          case 2:
            tmpFunctionInject = () => {
              for (let i = 0; i < currentItem.iouList.length; i++) {
                //淺複製 避免互相干擾
                let tmpItem = Object.assign({}, currentItem);
                tmpItem.chooseRepayment = tmpItem.iouList[i].iouNumber;
                this.getAmount(tmpItem, workIndex, () => {
                  tmpItem.amount =
                    tmpItem.iouObj.payBackLoanPrice +
                    tmpItem.iouObj.payBackInterest +
                    tmpItem.iouObj.payBackBreakPrice;
                  if (tmpItem.amount != 0) {
                    this.saveAddItem(tmpItem, workIndex);
                  }
                });
              }
            };
            break;
          case 6:
          case 3:
            tmpFunctionInject = () => {
              for (let i = 0; i < currentItem.iouList.length; i++) {
                let tmpItem = Object.assign({}, currentItem);
                tmpItem.chooseRepayment = tmpItem.iouList[i];
                this.getAmount(tmpItem, workIndex, () => {
                  if (tmpItem.amount != "0" && tmpItem.amount != "") {
                    this.saveAddItem(tmpItem, workIndex);
                  }
                });
              }
            };
            break;
          case 7:
            tmpFunctionInject = () => {
              currentItem.selectYear = new Date().getFullYear();

              this.getAmount(currentItem, workIndex, () => {
                if (currentItem.amount != "0" && currentItem.amount != "") {
                  this.saveAddItem(currentItem, workIndex);
                }
              });
            };
            break;
          case 4:
          case 8:
            tmpFunctionInject = () => {
              for (let i = 0; i < currentItem.iouList.length; i++) {
                //淺複製 避免互相干擾
                let tmpItem = Object.assign({}, currentItem);
                tmpItem.chooseRepayment = tmpItem.iouList[i].value;
                this.getAmount(tmpItem, workIndex, () => {
                  if (tmpItem.amount != 0) {
                    this.saveAddItem(tmpItem, workIndex);
                  }
                });
              }
            };
            break;
        }

        this.chooseType(workIndex, currentItem, false, tmpFunctionInject);
      }
    },
    /**
     * 開啟新增匯款項目
     * @param work 預設匯款對象
     * @param workIndex 匯款對象索引
     * @return void
     */
    openAddItem(work, workIndex) {
      this.currentIndex = workIndex;
      this.currentAddItem = Object.assign({}, this.defaultAddItem);
      this.inputDsabled = false;

      // 預設帶入目前的匯款對象
      this.addMemberObj = {
        memberType: work.memberType, // 1: 社員, 0: 準社員
        chooseMember: {
          id: work.memberId,
          account: work.account,
          name: work.name
        }
      };
      this.memberFilter.isFormal = work.memberType;

      this.$nextTick(() => {
        this.dialogAddItem = true;
      });
    },
    removeMember(workIndex) {
      this.works.splice(workIndex, 1);
      setTimeout(() => {
        this.workTimeOut(this.works);
      }, 100);
    },
    /**
     * 取得目前彈窗操作的社員資料
     * 如果彈窗中有選擇其他社員，優先回傳該社員；否則回傳卡片原本的社員
     */
    getTargetMember(workIndex) {
      // 判斷是否有另外選擇其他社員
      if (this.addMemberObj.chooseMember && this.addMemberObj.chooseMember.id) {
        return {
          id: this.addMemberObj.chooseMember.id,
          account: this.addMemberObj.chooseMember.account,
          name: this.addMemberObj.chooseMember.name,
        };
      }
      
      // 若無，回退使用原本的資料
      const originalWork = this.works[workIndex];
      return {
        id: originalWork.memberId,
        account: originalWork.account,
        name: originalWork.name
      };
    },
    saveAddItem(currentItem, currentIndex) {
      let date =
        parseInt($(`.selectDate`).val().split("-")[0]) +
        1911 +
        $(`.selectDate`).val().slice(3);

      // 取得當前目標社員資料
      const targetMember = this.getTargetMember(currentIndex);

      if (currentItem.type == 2) {
        if (currentItem.amount && currentItem.chooseRepayment) {
          // const newObj = JSON.parse(
          //     JSON.stringify(currentItem)
          // );
          const ioupayBackLoanPrice = currentItem.iouObj.payBackLoanPrice;
          const ioupayBackInterest = currentItem.iouObj.payBackInterest;
          const ioupayBackBreakPrice = currentItem.iouObj.payBackBreakPrice;
          const accountTitle = currentItem.iouObj.accountTitle;
          const thisAmount = this.$removeComma(currentItem.amount);
          let capitalObj = {
            isIouRow: true,
            iouRowSpan: 3,
            memberId: targetMember.id,
            memberAccount: targetMember.account,
            memberName: targetMember.name,
            name: `${accountTitle.capitalAccountTitle.code} ${accountTitle.capitalAccountTitle.name}`,
            accountTitleId: accountTitle.capitalAccountTitle.id,
            accountTitleCode: accountTitle.capitalAccountTitle.code,
            accountTitleName: accountTitle.capitalAccountTitle.name,
            type: "還款",
            loanIouNumber: currentItem.chooseRepayment,
            ioutObj: {
              amount: currentItem.iouObj.payBackPrice,
            },
            calculateAmount: ioupayBackLoanPrice,
            currentAmount:
              thisAmount - (ioupayBackBreakPrice + ioupayBackInterest) > 0
                ? thisAmount -
                  parseInt(
                    +Number(ioupayBackInterest) + Number(ioupayBackBreakPrice)
                  )
                : thisAmount - (ioupayBackBreakPrice + ioupayBackInterest) < 0
                ? 0
                : thisAmount - (ioupayBackBreakPrice + ioupayBackInterest),
            amount: this.$addcomma(thisAmount),
            show: `金額: ${ioupayBackLoanPrice}, 借據號: ${currentItem.chooseRepayment}`,
            summary: `借據號:${currentItem.chooseRepayment}`
          };
          let interestObj = {
            isIouRow: true,
            iouRowSpan: 0,
            memberId: targetMember.id,
            memberAccount: targetMember.account,
            memberName: targetMember.name,
            name: `${accountTitle.interestAccountTitleId.code} ${accountTitle.interestAccountTitleId.name}`,
            accountTitleId: accountTitle.interestAccountTitleId.id,
            accountTitleCode: accountTitle.interestAccountTitleId.code,
            accountTitleName: accountTitle.interestAccountTitleId.name,
            loanIouNumber: currentItem.chooseRepayment,
            // creditAmount: 0,
            type: "還款",
            calculateAmount: ioupayBackInterest,
            currentAmount:
              thisAmount - (ioupayBackBreakPrice + ioupayBackInterest) > 0
                ? ioupayBackInterest
                : thisAmount - ioupayBackBreakPrice < 0
                ? 0
                : thisAmount - ioupayBackBreakPrice,
            amount: 0,
            // addamount: currentItem.iouObj.payBackInterest,
            show: `金額: ${ioupayBackInterest}, 借據號: ${currentItem.chooseRepayment}`,
            summary: `借據號:${currentItem.chooseRepayment}`
          };
          let ldObj = {
            isIouRow: true,
            iouRowSpan: 0,
            memberId: targetMember.id,
            memberAccount: targetMember.account,
            memberName: targetMember.name,
            name: `${accountTitle.ldAccountTitleId.code} ${accountTitle.ldAccountTitleId.name}`,
            accountTitleId: accountTitle.ldAccountTitleId.id,
            accountTitleCode: accountTitle.ldAccountTitleId.code,
            accountTitleName: accountTitle.ldAccountTitleId.name,
            loanIouNumber: currentItem.chooseRepayment,
            // creditAmount: 0,
            type: "還款",
            calculateAmount: ioupayBackBreakPrice,
            currentAmount:
              thisAmount - ioupayBackBreakPrice > 0
                ? ioupayBackBreakPrice
                : thisAmount,
            amount: 0,
            // addamount: currentItem.iouObj.payBackBreakPrice,
            show: `金額: ${ioupayBackBreakPrice}, 借據號: ${currentItem.chooseRepayment}`,
            summary: `借據號:${currentItem.chooseRepayment}`
          };

          this.works[currentIndex].detail.push(capitalObj);
          this.works[currentIndex].detail.push(interestObj);
          this.works[currentIndex].detail.push(ldObj);

          this.works[currentIndex].amount = currentItem.amount;
          currentItem = this.defaultAddItem;
          this.dialogAddItem = false;
          this.isShowOptionSelection = false;
        } else {
          this.$message.closeAll();
          this.$message({
            type: "warning",
            message: "請選擇方案與金額",
          });
        }
      } else if (currentItem.type === 3) {
        if (currentItem.amount && currentItem.chooseRepayment) {
          const newObj = JSON.parse(JSON.stringify(currentItem));
          newObj.memberId = targetMember.id;
          newObj.memberAccount = targetMember.account;
          newObj.memberName = targetMember.name;
          newObj.name = this.accountTitleEnum[newObj.type].name;
          newObj.insPlanApplyNumber =
            currentItem.chooseRepayment.insPlanApplyNumber;
          newObj.accountTitleId = currentItem.chooseRepayment.accountTitleId;
          newObj.accountTitleCode =
            currentItem.chooseRepayment.accountTitleCode;
          newObj.accountTitleName = currentItem.chooseRepayment.accountTitleId;
          newObj.addamount = currentItem.amount;
          newObj.summary = currentItem.chooseRepayment.label;
          newObj.show = currentItem.chooseRepayment.label;
          newObj.creditAmount = currentItem.amount;
          newObj.disabled = true;
          this.works[currentIndex].detail.push(newObj);
          // this.newArr[currentIndex].detail.push(newObj);
          currentItem = this.defaultAddItem;
          this.dialogAddItem = false;
          this.isShowOptionSelection = false;
        } else {
          this.$message.closeAll();
          this.$message({
            type: "warning",
            message: "請輸入金額",
          });
        }
      } else if (currentItem.type === 4) {
        if (currentItem.amount) {
          let sixYearDataUserSelect = currentItem.sixYearData.data.filter(
            (sixYear) => sixYear.insSavingCode == currentItem.chooseRepayment
          )[0];
          let accountTitleSixYear = {
            memberId: targetMember.id,
            memberAccount: targetMember.account,
            memberName: targetMember.name,
            name: `${currentItem.sixYearData.enumData.accountTitleSixYear.code} ${currentItem.sixYearData.enumData.accountTitleSixYear.name}`,
            accountTitleId:
              currentItem.sixYearData.enumData.accountTitleSixYear.id,
            accountTitleCode:
              currentItem.sixYearData.enumData.accountTitleSixYear.code,
            accountTitleName:
              currentItem.sixYearData.enumData.accountTitleSixYear.name,
            type: currentItem.type,
            summary: currentItem.note,
            show: currentItem.note,
            rowspan: 1,
            chooseRepayment: "",
            amount: this.$addcomma(sixYearDataUserSelect.advAmount),
            addamount: this.$addcomma(sixYearDataUserSelect.advAmount),
            creditAmount: this.$addcomma(sixYearDataUserSelect.advAmount),
            display: true,
            insSavingCode: sixYearDataUserSelect.insSavingCode,
          };
          let accountTitleSixYearInterest = {
            memberId: targetMember.id,
            memberAccount: targetMember.account,
            memberName: targetMember.name,
            name: `${currentItem.sixYearData.enumData.accountTitleSixYearInterest.code} ${currentItem.sixYearData.enumData.accountTitleSixYearInterest.name}`,
            accountTitleId:
              currentItem.sixYearData.enumData.accountTitleSixYearInterest.id,
            accountTitleCode:
              currentItem.sixYearData.enumData.accountTitleSixYearInterest.code,
            accountTitleName:
              currentItem.sixYearData.enumData.accountTitleSixYearInterest.name,
            type: currentItem.type,
            summary: currentItem.note,
            show: currentItem.note,
            rowspan: 1,
            chooseRepayment: "",
            amount: this.$addcomma(sixYearDataUserSelect.advFeeAmount),
            addamount: sixYearDataUserSelect.advFeeAmount,
            creditAmount: sixYearDataUserSelect.advFeeAmount,
            display: true,
            insSavingCode: sixYearDataUserSelect.insSavingCode,
          };
          this.works[currentIndex].detail.push(accountTitleSixYear);
          this.works[currentIndex].detail.push(accountTitleSixYearInterest);
          currentItem = this.defaultAddItem;
          this.dialogAddItem = false;
          this.isShowOptionSelection = false;
        } else {
          this.$message.closeAll();
          this.$message({
            type: "warning",
            message: "請輸入金額",
          });
        }
      } else if (currentItem.type === 5) {
        if (currentItem.amount && currentItem.chooseRepayment) {
          const newObj = JSON.parse(JSON.stringify(currentItem));
          newObj.memberId = targetMember.id;
          newObj.memberAccount = targetMember.account;
          newObj.memberName = targetMember.name;
          newObj.name = `${currentItem.currentOtherItem.code} ${currentItem.currentOtherItem.name}`;
          newObj.accountTitleCode = currentItem.currentOtherItem.code;
          newObj.accountTitleName = currentItem.currentOtherItem.name;
          newObj.accountTitleId = currentItem.currentOtherItem.id;
          newObj.creditAmount = newObj.amount;
          newObj.summary = currentItem.note;
          newObj.show = currentItem.note;
          newObj.display = false;
          this.works[currentIndex].detail.push(newObj);
          // this.newArr.detail.push(newObj);
          currentItem = this.defaultAddItem;
          this.dialogAddItem = false;
          this.isShowOptionSelection = false;
        } else {
          this.$message.closeAll();
          this.$message({
            type: "warning",
            message: "請選擇會計科目並輸入金額",
          });
        }
      } else if (currentItem.type == 6) {
        if (currentItem.amount) {
          let accountTitleIou = currentItem.iouenumData.accountTitle;
          let iouBackPayPrice = currentItem.iouList;
          let iouObject = currentItem.iouenumData.iou;
          let agrObject = currentItem.iouenumData.agr;
          let accountTitlePriceMap = [
            {
              accountTitleName: "agrBackPayAccountTitle",
              objectName: "otherBackPay",
            },
            {
              accountTitleName: "interestAccountTitleId",
              objectName: "interestBackPay",
            },
            {
              accountTitleName: "ldAccountTitleId",
              objectName: "defBackPay",
            },
          ];
          accountTitlePriceMap.forEach((accountTitleMap) => {
            let accountTitleCurrent =
              accountTitleIou[accountTitleMap.accountTitleName];
            let priceItem = iouBackPayPrice[accountTitleMap.objectName];
            if (priceItem.length > 0) {
              let finalPriceTotal =
                priceItem[priceItem.length - 1].backPayPriceTotal;

              let accountTitleObject = {
                name: `${accountTitleCurrent.code} ${accountTitleCurrent.name}`,
                accountTitleCode: accountTitleCurrent.code,
                accountTitleName: accountTitleCurrent.name,
                accountTitleId: accountTitleCurrent.id,
                amount: this.$addcomma(finalPriceTotal),
                loanIouNumber: iouObject.iouNumber,
                loanIouAgrCode: agrObject.agreementCode,
                summary: `借據號 ${iouObject.iouNumber} 協議 ${agrObject.agreementCode} 前欠金額`,
                show: `借據號 ${iouObject.iouNumber} 協議 ${agrObject.agreementCode} 前欠金額`,
                display: true,
                memberId: targetMember.id,
                memberAccount: targetMember.account,
                memberName: targetMember.name,
                type: currentItem.type,
              };
              if (finalPriceTotal > 0) {
                this.works[currentIndex].detail.push(accountTitleObject);
              }
            }
          });

          currentItem = this.defaultAddItem;
          this.dialogAddItem = false;
          this.isShowOptionSelection = false;
        } else {
          this.$message.closeAll();
          this.$message({
            type: "warning",
            message: "請輸入金額",
          });
        }
      } else if (currentItem.type == 7) {
        if (currentItem.amount) {
          const newObj = JSON.parse(JSON.stringify(currentItem));

          newObj.memberId = targetMember.id;
          newObj.memberAccount = targetMember.account;
          newObj.memberName = targetMember.name;
          newObj.name = `${currentItem.iouObj.code} ${currentItem.iouObj.name}`;
          newObj.accountTitleCode = currentItem.iouObj.code;
          newObj.accountTitleName = currentItem.iouObj.name;
          newObj.accountTitleId = currentItem.iouObj.id;
          newObj.amount = currentItem.amount;
          newObj.annualCostYear = currentItem.selectYear;
          newObj.summary = currentItem.note;
          newObj.show = currentItem.note;
          newObj.disabled = true;
          this.works[currentIndex].detail.push(newObj);
          this.dialogAddItem = false;
          this.isShowOptionSelection = false;
        } else {
          this.$message.closeAll();
          this.$message({
            type: "warning",
            message: "請選擇年份(金額自動帶出)",
          });
        }
      } else if (currentItem.type === 8) {
        let obj = currentItem.currentOtherItem;
        let creditObj = currentItem.iouenumData.accountTitlePrincipalCredit;
        let guaranteeObj =
          currentItem.iouenumData.accountTitlePrincipalGuarantee;
        let pay = currentItem.iouenumData.accountTitlePay;
        let currentAddItem = currentItem.currentOtherItem;
        let loanIouDeadObj = {
          memberId: targetMember.id,
          memberAccount: targetMember.account,
          memberName: targetMember.name,
          name: `${obj.loanType == 1 ? creditObj.code : guaranteeObj.code} ${
            obj.loanType == 1 ? creditObj.name : guaranteeObj.name
          }`,
          accountTitleId: obj.loanType == 1 ? creditObj.id : guaranteeObj.id,
          accountTitleCode:
            obj.loanType == 1 ? creditObj.code : guaranteeObj.code,
          accountTitleName:
            obj.loanType == 1 ? creditObj.name : guaranteeObj.name,
          type: currentItem.type,
          objectType: currentItem.objectType,
          loanIouNumber: currentAddItem.iouNumber,
          amount: this.$addcomma(currentAddItem.iouPrincipalDealAmount),
          addamount: this.$addcomma(currentAddItem.iouPrincipalDealAmount),
          summary: currentItem.summary || "",
          show: `金額: ${currentAddItem.iouPrincipalDealAmount}  借據號: ${currentAddItem.iouNumber}`,
          display: true,
          by: currentItem.by,
        };
        let loanPayObj = {
          memberId: targetMember.id,
          memberAccount: targetMember.account,
          memberName: targetMember.name,
          name: `${pay.code} ${pay.name}`,
          accountTitleId: pay.id,
          accountTitleCode: pay.code,
          accountTitleName: pay.name,
          type: currentItem.type,
          objectType: currentItem.objectType,
          loanIouNumber: currentAddItem.iouNumber,
          amount: this.$addcomma(
            currentAddItem.iouDefNoPayAmount +
              currentAddItem.iouInterNoPayAmount +
              currentAddItem.iouLawNoPayAmount
          ),
          addamount: this.$addcomma(
            currentAddItem.iouDefNoPayAmount +
              currentAddItem.iouInterNoPayAmount +
              currentAddItem.iouLawNoPayAmount
          ),
          summary: currentItem.summary || "",
          show: `金額: ${
            currentAddItem.iouDefNoPayAmount +
            currentAddItem.iouInterNoPayAmount +
            currentAddItem.iouLawNoPayAmount
          }  借據號: ${currentAddItem.iouNumber}`,
          display: true,
          by: currentItem.by,
        };
        this.works[currentIndex].detail.push(loanPayObj);
        this.works[currentIndex].detail.push(loanIouDeadObj);
        currentItem = this.defaultAddItem;
        this.dialogAddItem = false;
        this.isShowOptionSelection = false;
      } else {
        if (currentItem.amount !== undefined && currentItem.amount !== null) {
          const newObj = JSON.parse(JSON.stringify(currentItem));
          newObj.memberId = targetMember.id;
          newObj.memberAccount = targetMember.account;
          newObj.memberName = targetMember.name;
          newObj.name =
            this.accountTitleEnum[newObj.type].code +
            " " +
            this.accountTitleEnum[newObj.type].name;
          newObj.accountTitleCode = this.accountTitleEnum[newObj.type].code;
          newObj.accountTitleName = this.accountTitleEnum[newObj.type].name;
          newObj.accountTitleId = this.accountTitleEnum[newObj.type].id;
          newObj.amount = this.$addcomma(currentItem.amount);
          newObj.creditAmount = currentItem.amount;
          newObj.summary = currentItem.note;
          newObj.show = currentItem.note;
          newObj.tradeDate = date;
          newObj.display = false;
          this.works[currentIndex].detail.push(newObj);
          // this.newArr.detail.push(newObj);
          currentItem = this.defaultAddItem;
          this.dialogAddItem = false;
          this.isShowOptionSelection = false;
        } else {
          this.$message.closeAll();
          this.$message({
            type: "warning",
            message: "請輸入金額",
          });
        }
      }
    },
    removeItem(workIndex, itemIndex) {
      if (this.works[workIndex].detail[itemIndex].isIouRow) {
        this.works[workIndex].detail.splice(itemIndex, 3);
      } else {
        this.works[workIndex].detail.splice(itemIndex, 1);
      }
    },
    totalPayment(work) {
      let total = 0;
      work.detail.map((item) => {
        total += parseInt(item.amount.toString().replace(/,/g, ""), 10);
      });
      this.totalAmouts = total;
      return this.$addcomma(total);
    },
    allMemberTotalPayment() {
      let total = 0;
      this.works.map((work) => {
        work.detail.map((item) => {
          total += parseInt(item.amount.toString().replace(/,/g, ""), 10);
        });
      });
      return this.$addcomma(total);
    },
    getGlossary() {
      let url = API.coopGlossary;
      this.$http.get(url).then((res) => {
        this.Glossary = res.data.resultData.data.map((item) => {
          return {
            label: item.code,
            value: item.content,
          };
        });
      });
    },
    submit() {
      const vm = this;
      const url = API.memberTransferMemo + "?action=createVoucher";
      const form = new FormData();
      if (this.works.length == 0) {
        this.$message.closeAll();
        this.$message({
          type: "warning",
          message: "目前尚未選擇傳票",
        });
        return;
      }

      form.append("transferId", this.subId);
      form.append(
        "memberTransferMemoVoucher",
        JSON.stringify(this.tranferData)
      );
      const thenCB = (json) => {
        this.$message.closeAll();
        this.$message({
          type: "success",
          message: "已開立傳票",
        });
        vm.reportIdList = json.resultData;
        // 轉帳備忘錄有臨櫃作業與社員搜尋兩個入口，子路由名稱不同，
        // 依 :id 選對才不會掉出社員情境（詳見 router.js cabinet_transfer）
        const memberId = this.$route.params.id;

        this.$router.push(
          memberId == null
            ? {
                name: "cabinet_transfer_summons_print",
                params: { Num: vm.reportIdList },
              }
            : {
                name: "cabinet_member_transfer_summons_print",
                params: { id: memberId, Num: vm.reportIdList },
              }
        );
      };
      this.mAxiosPost(url, form, thenCB);
    },
    viewNote() {
      setTimeout(() => {
        $(".min_go_date").datepicker({
          changeYear: true,
          changeMonth: true,
          currentText: "今天",
          dateFormat: "Rmmdd",
          showButtonPanel: true,
          yearRange: "1912:c+10",
        });
        let date =
          parseInt(this.recordToEdit.transferDate.split(" ")[0].split("-")[0]) -
          1911 +
          this.recordToEdit.transferDate.split(" ")[0].slice(4);
        $(`.transferDate`).val(`${date}`);
      }, 1);

      this.dialogTransferView = true;
    },
    importGlossary(index) {
      if (!this.works[index].Glossary) {
        this.$message.closeAll();
        this.$message({
          type: "warning",
          message: "請先選擇詞彙",
        });
      } else {
        if (this.works[index].remark == "") {
          this.$nextTick(() => {
            this.works[index].remark = this.works[index].Glossary;
          });
        } else {
          this.$nextTick(() => {
            this.works[index].remark += `,${this.works[index].Glossary}`;
          });
        }
      }
    },
    setYearList() {
      let date = new Date();
      let Y = date.getFullYear();
      let YearArr = [];
      for (let i = 0; i < 3; i++) {
        let yearObj = {
          label: String(Y - i - 1911),
          value: Number(Y - i),
        };
        YearArr.push(yearObj);
      }
      this.yearList = YearArr;
    },
    workTimeOut(works) {
      works.forEach((item, idx) => {
        setTimeout(() => {
          $(`.chooseDate${idx}`).datepicker({
            changeYear: true,
            changeMonth: true,
            currentText: "今天",
            dateFormat: "Rmmdd",
            showButtonPanel: true,
            defaultDate: null,
            onSelect: (data) => {},
          });
          if (item.tradeDate) {
            let mingoDate =
              parseInt(this.works[idx].tradeDate.split("-")[0]) - 1911 < 100
                ? `0${
                    parseInt(this.works[idx].tradeDate.split("-")[0]) - 1911
                  }${this.works[idx].tradeDate.slice(4)}`
                : `${
                    parseInt(this.works[idx].tradeDate.split("-")[0]) - 1911
                  }${this.works[idx].tradeDate.slice(4)}`;

            $(`.chooseDate${idx}`).val(mingoDate);
          } else {
            $(`.chooseDate${idx}`).val("");
          }
        }, 200);
      });
    },
    resetAddAmount(amount) {
      return (this.currentAddItem.amount = this.$addcomma(
        this.$removeComma(amount)
      ));
    },
    resetAmount(amount, workIndex, itemIndex) {
      if (this.works[workIndex].detail[itemIndex].isIouRow) {
        let amount = this.$removeComma(
          this.works[workIndex].detail[itemIndex].amount
        );

        for (let i = itemIndex + 2; i >= itemIndex; i--) {
          let tmpAmount =
            amount > this.works[workIndex].detail[i].calculateAmount &&
            i != itemIndex
              ? this.works[workIndex].detail[i].calculateAmount
              : amount;
          this.works[workIndex].detail[i].currentAmount = tmpAmount;

          amount -= tmpAmount;
          //   if (amount == 0) {
          //     break;
          //   }
        }
      }
      this.works[workIndex].detail[itemIndex].amount = this.$addcomma(
        this.$removeComma(amount)
      );
    },
    back() {
      if (this.$route.params.id == null) {
        this.$router.push({ name: "cabinet_transfer_all" });
      } else {
        this.$router.push({
          name: "cabinet_transfer",
          params: {
            id: this.$route.params.id,
            detail: this.dataArr,
          },
        });
      }
    },
    renderCauculateString(
      interestRateDetail,
      paymentType,
      isBreakPrice = false
    ) {
      let result = "";
      interestRateDetail.forEach((rateDetail) => {
        let date = {
          beginDate: this.$transferDate(rateDetail.beginDate),
          endDate: this.$transferDate(rateDetail.endDate),
        };
        let dateDiff = rateDetail.dateDiff;
        let interestRate = rateDetail.interestRate;
        let interest =
          paymentType == 2
            ? rateDetail.interestMonthly
            : rateDetail.interestDaily;
        let loanPrice = rateDetail.loanPrice;
        result += `${date["beginDate"]} ~ ${date["endDate"]} ${dateDiff}天 ${
          isBreakPrice ? "利息" : "本金"
        }${this.$addcomma(
          loanPrice || "0"
        )}元 年利率 ${interestRate}% 共 ${this.$addcomma(interest || "0")} 元 `;
      });

      return result;
    },
  },
};
</script>
<style lang="scss" scoped>
.block-content {
  .box-card {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }

    .table {
      td {
        vertical-align: middle;
      }
    }

    .mw100p {
      max-width: 100%;
    }

    .group {
      td {
        padding: 8px;
        text-align: right;

        &:nth-child(3) {
          text-align: center;
        }
      }
    }

    .join {
      p {
        margin: 10px 0;
        font-weight: bold;

        span {
          font-weight: normal;
        }
      }
    }
  }
}
.date {
  font-size: 14px;
  display: inline-block;
  position: relative;
  margin-bottom: 10px;
}
.el-form ::v-deep {
	#listform {
		.block-content {
			padding: 0;
		}
	}
}
</style>